import React, {useEffect, useRef} from 'react';
import {useNavigate, useLocation, Outlet} from 'react-router-dom';
import {appConstants, useDataSync} from "../../shared";
import { notificationService } from '../../shared/lib/notification/notification';

function AppLoader() {
    const navigate = useNavigate();
    const location = useLocation();
    const LAST_PATH_KEY = appConstants.localStorageKeyLastPath;
    const INDEX_PATH = appConstants.indexRouterDomPath;
    const firstRenderRef = useRef(true)

    useEffect(() => {
        notificationService.init();
    }, []);

    const {isUpdateAvailable, confirmUpdate, isUpdating} = useDataSync();
    const updateNotificationIdRef = useRef(null);

    // Determine if it's the very first data load
    const isFirstLoadEver = !localStorage.getItem(appConstants.localStorageMetaPrefix + 'versions');

    // Toast should show if it's updating automatically OR if a manual update is available
    const isToastOpen = isUpdating || isUpdateAvailable;

    const toastMessage = isUpdating
        ? (isFirstLoadEver ? "Перше завантаження даних..." : "Оновлення даних...")
        : "Доступні нові дані";

    useEffect(() => {
        // Якщо тост має бути відкритий
        if (isToastOpen) {
            // Видаляємо попереднє сповіщення, якщо воно було (щоб не дублювати)
            if (updateNotificationIdRef.current) {
                notificationService.remove(updateNotificationIdRef.current);
            }

            const actions = isUpdating ? null : [
                {label: 'Оновити Зараз', callback: confirmUpdate}
            ];

            // Створюємо нове сповіщення
            const id = crypto.randomUUID();
            updateNotificationIdRef.current = id;

            notificationService.add(toastMessage, 'info', isUpdating ? 0 : 5000, actions, id);
        } else {
            // Якщо тост має закритися (оновлення завершено)
            if (updateNotificationIdRef.current) {
                notificationService.remove(updateNotificationIdRef.current);
                updateNotificationIdRef.current = null;
            }
        }
    }, [isToastOpen, isUpdating, toastMessage, confirmUpdate]);

    useEffect(() => {
        const lastPath = localStorage.getItem(LAST_PATH_KEY);
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
            if (lastPath && lastPath !== location.pathname) {
                if (location.pathname === '/' && lastPath === INDEX_PATH) {

                } else if (location.pathname !== lastPath) {
                    navigate(lastPath, {replace: true});
                    return;
                }
            }

            if (location.pathname === '/') {
                navigate(INDEX_PATH, {replace: true});
                return;
            }
        }

        if (location.pathname !== '/login') {
            localStorage.setItem(LAST_PATH_KEY, location.pathname);
        }

    }, [location.pathname, navigate, INDEX_PATH, LAST_PATH_KEY]);


    const actions = isUpdating ? null : [
        {label: 'Оновити Зараз', callback: confirmUpdate}
    ];


    return (
        <div key={isUpdating.toString()}>
            <Outlet/>
        </div>
    );
}

export {AppLoader};
